export const GET_WORD_DATA_REQUEST = "DICTIONARY::GET_WORD_DATA_REQUEST";
export const GET_WORD_DATA_SUCCESS = "DICTIONARY::GET_WORD_DATA_SUCCESS";
export const GET_WORD_DATA_ERROR = "DICTIONARY::GET_WORD_DATA_ERROR";
export const FETCH_WORD_DATA = "DICTIONARY::FETCH_WORD_DATA";
